export const Feature_NAMESPACES = {
  AUTH: "auth",
  ACTIVITY_LOG: "activity-log",
  BENCHMARK_DASHBOARD: "benchmark-dashboard",
  BILL_OCR: "bill-ocr",
  CALL_FOR_HELP: "call-for-help",
  CARBON_INVENTORY: "carbon-inventory",
  COMPANY: "company",
  CUSTOM_FRAMEWORK: "custom-framework",
  DASHBOARD: "dashboard",
  DATA_ENTRY: "data-entry",
  ESG: "esg",
  ORGANIZATION: "organization",
  REPORTING_BOUNDARY: "reporting-boundary",
  METRIC_ASSIGNMENT: "metric-assignment",
  ESG_DASHBOARD_V3: "esg-dashboard-v3",
  G_ELEMENT: "g-element",
  MORE_SOLUTIONS: "more-solutions",
  NOTIFICATIONS: "notifications",
  ONBOARDING: "onboarding",
  ORGANIZATION: "organization",
  SETTINGS: "settings",
  SURVEY_MANAGEMENT: "survey-management",
  SURVEYS: "surveys",
  TARGET_SETUP: "target-setup",
  USER_MANAGEMENT: "userManagement",
};
